import React, { useState, useEffect ,useCallback} from "react";
import { TableBody, Table, TableContainer, TableHead, TableRow, TextField, TableCell, Button } from "@mui/material";
import { Row, Col, Card } from "react-bootstrap";
import { MyDiv, HeadingFour } from "../Common/Components";
import swal from "sweetalert2";
import moment from "moment";
import { postRequest,getRequest } from "../Common/api/apiService";


export default function ProjectNotes(projectId) {
  const [notes, setNotes] = useState([]);
  const [projectNotes, setProjectNotes] = useState("");
  const projectID = projectId.projectId;
  const addNotes = event => {
    setProjectNotes(event.target.value);
  };

  // Fetching notes
const getProjectNotes = useCallback(async () => {
  try {
    const url = `fetch-notes/${projectID}`;
    const response = await getRequest(url);

    setNotes(response.data.pm_pro_notes);
    console.log("received notes", response.data);
  } catch (error) {
    console.error("Notes Fetch Error:", error);
    swal.fire({
      text: error.response?.data || "Error fetching resources",
      icon: "error",
    });
  }
}, [projectID]);

useEffect(() => {
  getProjectNotes();
}, [getProjectNotes]);

// Submitting notes
const submitHandler = useCallback(
  async (e) => {
    e.preventDefault();
    console.log("submitHandler called");

    try {
      const url = `add-notes/${projectID}`;
      const payload = { notes: projectNotes };

      const response = await postRequest(url, payload);

      swal.fire({
        text: response.data,
        icon: "success",
      });

      getProjectNotes(); // refresh after save
    } catch (error) {
      console.error("Notes Submit Error:", error);
      swal.fire({
        text: error.response?.data || "Error fetching notes",
        icon: "error",
      });
    }
  },
  [projectID, projectNotes, getProjectNotes]
);

  return (
    <Card className="LayoutCard">
      <Card.Header>
        <HeadingFour>Project Notes</HeadingFour>
      </Card.Header>
      <Card.Body>
        <Row>
          <Col md={12}>
            <MyDiv className="GeneralTable pxy-0 mt-0 ">
              <TableContainer>
                <Table className="bgGrey mt-0" aria-label="Milestone table">
                  <TableHead>
                    <TableRow>
                      <TableCell align="left">Date</TableCell>
                      <TableCell align="left">Notes</TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {notes.length > 0 &&
                      notes.map(note => (
                        <React.Fragment key={note._id}>
                          <TableRow>
                            <TableCell>{moment(note?.created).format("MMM-DD-YYYY hh:mm a")}</TableCell>
                            <TableCell>{note?.notes}</TableCell>
                          </TableRow>
                        </React.Fragment>
                      ))}
                  </TableBody>
                </Table>
              </TableContainer>
            </MyDiv>
          </Col>
        </Row>

        <form onSubmit={e => submitHandler(e)}>
          <Row>
            <Col md={6}>
              <TextField
                required
                id="projectNotes"
                fullWidth
                InputLabelProps={{ shrink: true }}
                label="Add Notes"
                value={projectNotes}
                variant="outlined"
                onChange={e => addNotes(e)}
              />
            </Col>
            <Col md={6}>
              <Button className="btn primary-btn mt-2" type="submit">
                Add Note
              </Button>
            </Col>
          </Row>
        </form>
      </Card.Body>
    </Card>
  );
}
